// removed by extract-text-webpack-plugin
module.exports = {"ConfirmPage":"_7iqVMcnjVFapoVhsdB9K5","Container":"_2Lw3EdWHPJVHmIXymikEew","SuccessIcon":"_3Lr3de864E54qE8o-AiuDG","ErrorIcon":"_3lc1jQCuackR7nvD93BVS2","Title":"_3TbmuouGXOduzC-vOZE-UJ","Text":"bt0bYX_fc2-OnT3OQYzPa","Actions":"_3r-7U9lpM6VTmFF8v_Cd96","Btn":"ixSgyPxwOOH3gjocZCjud","BtnSecondary":"_2-JxPL26z5fJso-xzXkk8T"};


//////////////////
// WEBPACK FOOTER
// ./src/PagesOfCommon/Сonfirmation/styles.module.css
// module id = 626
// module chunks = 0